import React from 'react';
import { Link } from 'react-router-dom';
import './ThankYou.css';

const ThankYou = () => {
  return (
    <main className="thank-you-page">
      <section className="thank-you-content" aria-labelledby="thank-you-title">
        <span className="thank-you-mark">❆</span>
        <span className="thank-you-eyebrow">Message received</span>
        <h1 id="thank-you-title">Thank you</h1>
        <p>We received your request and our team will be in touch soon.</p>
        <Link className="thank-you-link" to="/">
          Return to homepage <span aria-hidden="true">-&gt;</span>
        </Link>
      </section>
    </main>
  );
};

export default ThankYou;
